const GOOGLE_IDENTITY_SCRIPT_URL = 'https://accounts.google.com/gsi/client';
const GOOGLE_IDENTITY_SCRIPT_ATTR = 'data-dobi-google-identity';
let pending: Promise<boolean> | null = null;

function isGoogleIdentityReady() {
  return Boolean(window.google?.accounts?.id);
}

/** A failed or blocked GIS request must settle and be removable so the user can retry. */
export function loadGoogleIdentityScript(timeoutMs = 12_000): Promise<boolean> {
  if (isGoogleIdentityReady()) return Promise.resolve(true);
  if (pending) return pending;

  pending = new Promise<boolean>((resolve) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[${GOOGLE_IDENTITY_SCRIPT_ATTR}]`);
    const script = existing ?? document.createElement('script');
    let settled = false;
    const finish = (ready: boolean) => {
      if (settled) return;
      settled = true;
      window.clearInterval(poll);
      window.clearTimeout(timeout);
      script.removeEventListener('error', onError);
      if (!ready) script.remove();
      resolve(ready);
    };
    const onError = () => finish(false);
    const poll = window.setInterval(() => {
      if (isGoogleIdentityReady()) finish(true);
    }, 100);
    const timeout = window.setTimeout(() => finish(isGoogleIdentityReady()), timeoutMs);
    script.addEventListener('error', onError, {once: true});
    if (!existing) {
      script.setAttribute(GOOGLE_IDENTITY_SCRIPT_ATTR, '');
      script.src = GOOGLE_IDENTITY_SCRIPT_URL;
      script.async = true;
      document.head.appendChild(script);
    }
  }).finally(() => { pending = null; });
  return pending;
}
